import BackNavigationArrow from "@/components/views/BackNavigationArrow";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useGetInstitution } from "../../../common/api/queries";
import { EntityIdObject } from "../../../common/types";
import { InstitutionForm } from "../components/forms/InstitutionForm";

export const InstitutionDetailContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data, isError } = useGetInstitution(id);

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2>{t("institution.titles.update")}</h2>
          </BackNavigationArrow>
        }
      >
        <DisplayWrapper itemLoaded={!!data} isError={isError}>
          <InstitutionForm institution={data} />
        </DisplayWrapper>
      </Card>
    </ContentWrapper>
  );
};
